<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">REVISIÓN DE INGRESO Y SALIDA{{ item.per_numero_documento }}</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-6">
            <p>
              <small>
                <b>{{item.emp_razon_social}}</b><br />
                <b>RUBRO: </b>{{item.rubro_descripcion}}<br />
                <b>LUGAR: </b>{{item.nombre_departamento +' - '+ item.nombre_municipio}}
              </small>
            </p>
          </div>
          <div class="col-12 col-md-6 text-right">
            <router-link
              class="btn btn-outline-info btn-sm"
              :to="{ name: 'empresas' }"
              title="Regresar a empresas">
              <i class="fa fa-arrow-left"></i>
            </router-link> 
          </div>
        </div>
        <div class="row">
          <!--Izquierda-->
          <div class="col-12 col-md-6">
            <h6 class="mt-4">Lista de personas para registrar ingreso (Check in):</h6>
            <div class="row table-responsive" style="overflow-y:scroll; height:360px;">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr class="text-center">
                    <th><small class="font-weight-bold">#</small></th>
                    <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                    <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                    <th><small class="font-weight-bold">FECHA NACIMIENTO</small></th>
                    <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                    <th><small class="font-weight-bold">ACCIÓN</small></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in extranjeros" :key="index">
                    <td>
                      <small>{{ index + 1 }}</small>
                    </td>
                    <td><small>{{ item.nombre_completo }}</small></td>
                    <td class="text-center"><small> {{ item.per_numero_documento }}</small></td>
                    <td class="text-center"><small>{{ item.fecha_nacimiento }}</small></td>
                    <td class="text-center"><small>{{ item.nacionalidad }}</small></td>
                    <td class="text-center">
                      <a
                        class="btn btn-outline-info btn-sm"
                        @click="registrarParte(item)"
                        title="Registrar Ingreso"
                      >
                        <i class="fa fa-chevron-right"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--Derecha-->
          <div class="col-12 col-md-6">
            <h6 class="mt-4">Lista de personas para registrar salida (Check out):</h6>
            <div class="table-responsive" style="overflow-y:scroll; height:380px;">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr class="text-center">
                    <th><small class="font-weight-bold">#</small></th>
                    <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                    <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                    <th><small class="font-weight-bold">FECHA INGRESO</small></th>
                    <th><small class="font-weight-bold">FECHA SALIDA</small></th>
                    <th><small class="font-weight-bold">ACCIONES</small></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in extrajerosPartes" :key="index">
                    <td>
                      <small>{{ index + 1 }}</small>
                    </td>
                    <td>
                      <small>{{ item.nombre_completo }}</small><br />
                      <small class="font-size-10">{{ item.per_numero_documento }}</small>
                    </td>
                    <td class="text-center"><small>{{ item.nacionalidad }}</small></td>
                    <td class="text-center"><small>{{ item.fecha_inicio }}</small></td>
                    <td>
                      <small v-if="item.fecha_fin != '' && item.fecha_fin != null">
                        {{item.fecha_fin}}
                      </small>
                      <small v-else>
                        <span class=" badge badge-success text-white">Continúa <br> Hospedado</span>
                      </small>
                    </td>
                    
                    <td class="text-center">
                      <a
                        class="btn btn-outline-danger btn-sm mb-1"
                        @click="deleteParte(item.id_parte)"
                        title="Cancelar Registro"
                        v-if="item.estado_parte == 1"
                      >
                        <i class="fa fa-chevron-left"></i>
                      </a>
                      
                      <a
                        class="btn btn-outline-success btn-sm mb-1"
                        @click="salidaParte(item.id_parte)"
                        title="Registrar Salida"
                        v-if="item.estado_parte == 1"
                      >
                        <i class="fa fa-reply"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!--Modal-->
    <b-modal
      class="modal fade"
      :title="tituloModal"
      size="xl"
      hide-footer
      ref="registrarPersona"
      :no-close-on-backdrop="true"
    >
      <div class="container">
        <form @submit.prevent="registrarPersona">
          <div class="row mb-2">
            <div class="form-group col-md-3">
              <label class="mr-1">Tipo Documento:</label>
              <span
                class="text-danger text-help"
                v-if="!$v.personaNuevo.par_tipo_documento.required"
                ><small>Campo requerido</small>
              </span>
              <select
                class="custom-select"
                v-model="personaNuevo.par_tipo_documento"
                :class="{
                  'is-invalid':
                    submitted && $v.personaNuevo.par_tipo_documento.$error,
                }"
              >
                <option
                  v-for="t in tipoDocumentos"
                  :value="t.nombre"
                  :key="t.nombre"
                  >{{ t.nombre }}</option
                >
              </select>
            </div>

            <div class="col-md-3">
              <label class="mr-1">Nro. Documento:</label>
              <span
                class="text-danger text-help"
                v-if="!$v.personaNuevo.per_numero_documento.required"
                ><small>Campo requerido</small>
              </span>
              <input
                type="text"
                placeholder="Ej.: EX234223"
                class="form-control"
                v-model="personaNuevo.per_numero_documento"
                :class="{
                  'is-invalid':
                    submitted && $v.personaNuevo.per_numero_documento.$error,
                }"
                @keyup="personaNuevo.per_numero_documento = personaNuevo.per_numero_documento.toUpperCase()"
              />
            </div>

            <div class="col-md-6">
              <label class="mr-1">Nombres:</label>
              <span
                class="text-danger text-help"
                v-if="!$v.personaNuevo.per_nombres.required"
                ><small>Campo requerido</small>
              </span>
              <input
                type="text"
                placeholder="Ej.: Juan Manuel"
                class="form-control"
                v-model="personaNuevo.per_nombres"
                :class="{
                  'is-invalid': submitted && $v.personaNuevo.per_nombres.$error,
                }"
                @keyup="personaNuevo.per_nombres = personaNuevo.per_nombres.toUpperCase()"
              />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-md-3">
              <label class="mr-1">Primer Apellido:</label>
              <span
                class="text-danger text-help"
                v-if="!$v.personaNuevo.per_primer_apellido.required"
                ><small>Campo requerido</small>
              </span>
              <input
                type="text"
                placeholder="Ej.: Mamani"
                class="form-control"
                v-model="personaNuevo.per_primer_apellido"
                :class="{
                  'is-invalid':
                    submitted && $v.personaNuevo.per_primer_apellido.$error,
                }"
                @keyup="personaNuevo.per_primer_apellido = personaNuevo.per_primer_apellido.toUpperCase()"
              />
            </div>

            <div class="col-md-3">
              <label>Segundo Apellido:</label>
              <input
                type="text"
                placeholder="Ej.: Quispe"
                class="form-control"
                v-model="personaNuevo.per_segundo_apellido"
                @keyup="personaNuevo.per_segundo_apellido = personaNuevo.per_segundo_apellido.toUpperCase()"
              />
            </div>

            <div class="col-md-3">
              <label>Otro Apellido:</label>
              <input
                type="text"
                placeholder="Ej.: Quispe"
                class="form-control"
                v-model="personaNuevo.per_otro_apellido"
                @keyup="personaNuevo.per_otro_apellido = personaNuevo.per_otro_apellido.toUpperCase()"
              />
            </div>

            <div class="col-md-3">
              <label class="mr-1">F. Nacimiento:</label>
              <span
                class="text-danger text-help"
                v-if="!$v.personaNuevo.per_fecha_nacimiento.required"
                ><small>Campo requerido</small>
              </span>
              <Fecha
                v-model="personaNuevo.per_fecha_nacimiento"
                :class="{
                  'is-invalid':
                    submitted && $v.personaNuevo.per_fecha_nacimiento.$error,
                }"
              />
            </div>
          </div>

          <div class="row mb-2">
            <div class="form-group col-md-3">
              <label class="mr-1">Nacionalidad:</label>
              <model-select
                :options="options"
                v-model="personaNuevo.par_nacionalidad"
                placeholder="Seleccione País"
              >
              </model-select>
            </div>

            <div class="form-group col-md-3">
              <label class="mr-1">Genero:</label>
              <span
                class="text-danger text-help"
                v-if="!$v.personaNuevo.par_genero.required"
                ><small>Campo requerido</small>
              </span>
              <select
                class="custom-select"
                v-model="personaNuevo.par_genero"
                :class="{
                  'is-invalid': submitted && $v.personaNuevo.par_genero.$error,
                }"
              >
                <option
                  v-for="t in tipoSexos"
                  :value="t.codigo"
                  :key="t.nombre"
                  >{{ t.nombre }}</option
                >
              </select>
            </div>

            <div class="col-md-3">
              <label class="mr-1">Email:</label>
              <span
                class="text-danger text-help"
                v-if="!$v.personaNuevo.per_email.required"
                ><small>Campo requerido</small>
              </span>
              <input
                type="text"
                placeholder="Ej.: xxx@xxx.com"
                class="form-control"
                v-model="personaNuevo.per_email"
                :class="{
                  'is-invalid': submitted && $v.personaNuevo.per_email.$error,
                }"
              />
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-md-6">
              <a @click="hideModalPersona" class="btn btn-secondary col-md-12"
                >Cancelar</a
              >
            </div>

            <div class="col-md-6">
              <b-button class="btn-block btn-info" type="submit"
                >Registrar</b-button
              >
            </div>
          </div>
        </form>
      </div>
    </b-modal> 
    <Loading v-show="cargando"  />
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import moment from "moment";
import Fecha from "../../components/FechaNacimiento";
import { ModelSelect } from "vue-search-select";

export default {
  name: 'centroHospedaje',
  components: {
    Loading,
    Fecha,
    ModelSelect,
  },
  data() {
    return {
      tituloModal: "REGISTRO DE PERSONA",
      empresa: {},
      persona: {},
      empresas: [],
      fechaInicio: '',
      fechaFin: '',
      divSemPer: false,
      divDir: false,
      divStr: false,
      parte: {
        condicion: 'SERVICIO'
      }, 
      estadoBoton: true,
      buscarNumeroDocumento: '',
      buscarNombres: '',
      buscarApellidos: '',
      extranjeros: [],
      extrajerosPartes: [],
      personaNuevo: {},
      submitted: false,
      tipoSexos: [],
      options: [],
      // item: {
      //   value: "",
      //   text: "",
      // },
      item: {},
      tipoDocumentos: [],
      dismissSecs: 2,
      dismissCountDown: 0,
      dismissSecsDelete: 2,
      dismissCountDownDelete: 0,
      tipo_servicio: '',
      cargando: false,
      id_empresa: 0,
    };
  },
  methods: {
    async getPersonaLogin() {
      let config = { headers: { token: this.token } };
      try {
        this.resultados = await this.axios.get(`/personaGetDataLogin`, config);
        this.persona = this.resultados.data.contenido;
        
        this.getEmpresas(this.persona.id_persona);
        
      } catch (error) {
        console.log(error);
      }
    },
    async getEmpresas(id_persona) {
      try {
        let resultados = await this.axios.get(`/empresas/${id_persona}`);
        this.empresas = resultados.data.contenido;
      } catch (error) {
        console.log(error);
      }
    },
    async getPersonaCentroHospedaje(id_empresa) {
      try {
        let resultados = await this.axios.get(`/personaCentroHospedaje/${id_empresa}`);
        if(resultados.status == 200){
          this.cargando = false;
          this.extranjeros = resultados.data.contenido;
        }

      } catch (error) {
        console.log(error);
      }
    },
    async logicaDeCampos(empresa) {

      this.tipo_servicio = empresa.tipo_servicio;
      this.extranjeros = [];
      
      try {
        let resultados = await this.axios.get(
          `/getRubro/${empresa.id_rubro}`
        );

        this.rubro = resultados.data.contenido;

        if(this.rubro.dias == 0){
          this.restarDias(1);
          this.parte.fecha_inicio = this.parte.fecha_fin;
        } else {
          this.restarDias(this.rubro.dias);
        }
        
        this.buscarExtranjeroEnPartes(this.parte.fecha_inicio, this.parte.fecha_fin, this.empresa.id_empresa);
        this.renderizarInterfaces(this.rubro.tipo_accion);
        this.estadoBoton = false;

      } catch (error) {
        console.log(error);
        Swal.fire(
          "ERROR",
          `Ocurrio un Error al realizar la consulta!`,
          "error"
        );
      }
    },
    async buscarExtranjero(buscarNumeroDocumento, buscarNombres, buscarApellidos) {
      if (buscarNumeroDocumento == "") buscarNumeroDocumento = "0";
      if (buscarNombres == "") buscarNombres = "0";
      if (buscarApellidos == "") buscarApellidos = "0";

      this.cargando = true;

      try {
        let resultados = await this.axios.get(`/buscarPersona/${buscarNumeroDocumento}/${buscarNombres}/${buscarApellidos}`);
        this.extranjeros = resultados.data.contenido;
      } catch (error) {
        console.log('Erro catch: ', error);
      }
    },
    async buscarExtranjeroEnPartes(fechaInicio, fechaFin, id_empresa) {
      this.cargando = true;

      try {
        let resultados = await this.axios.get(`/persona/extranjerosEnPartes/${fechaInicio}/${id_empresa}`);
        this.extrajerosPartes = resultados.data.contenido;
      } catch (error) {
        console.log('Error catch: ', error);
        
      }
    },
    restarDias(dias){

      let hoy = new Date();
      let diaEnMilesegundos = 1000 * 60 * 60 * 24 * dias;
      let fechaResta = hoy.getTime() - diaEnMilesegundos;
      let fechaDiaAtras = new Date(fechaResta);

      //let inicio = `${fechaDiaAtras.getFullYear()}-${fechaDiaAtras.getMonth() + 1}-${fechaDiaAtras.getDate()}`;
      //let fin = `${hoy.getFullYear()}-${hoy.getMonth() + 1}-${hoy.getDate()}`;

      let  vDiaAtras = (fechaDiaAtras.getDate() < 10) ? "0" + fechaDiaAtras.getDate() : fechaDiaAtras.getDate();
      let  vMesAtras = ((fechaDiaAtras.getMonth()+1) < 10) ? "0" + (fechaDiaAtras.getMonth()+1) : fechaDiaAtras.getMonth();

      let vDiaHoy = (hoy.getDate() < 10) ? "0" + hoy.getDate() : hoy.getDate();
      let vMesHoy = ((hoy.getMonth()+1) < 10) ? "0" + (hoy.getMonth()+1) : hoy.getMonth();

      this.fechaInicio = `${fechaDiaAtras.getFullYear()}-${vMesAtras}-${vDiaAtras}`;
      this.fechaFin = `${hoy.getFullYear()}-${vMesHoy}-${vDiaHoy}`;

      this.parte.fecha_inicio = this.fechaInicio;
      this.parte.fecha_fin = this.fechaFin;
    },
    renderizarInterfaces(condicion){

      if(condicion == 'ESTATICO_COMPUESTO'){
        
        this.divSemPer = true;
        this.divDir = false;
        this.divStr = false;

      }

      if(condicion == 'ESTATICO_SIMPLE'){

        this.divSemPer = false;
        this.divDir = true;
        this.divStr = false;

      }

      if(condicion == 'DINAMICO'){

        this.divSemPer = false;
        this.divDir = false;
        this.divStr = true;

      }
    },
    async registrarParte(persona) {
      this.cargando = true;
      try {
        this.parte.id_persona = persona.id_persona;
        this.parte.id_empresa = this.id_empresa;
        //this.parte.fecha_inicio = moment().format("YYYY-MM-DD HH:mm:ss");
        //this.parte.fecha_fin = null;
        this.parte.condicion = persona.tipo_servicio;
        
        await this.axios.post(`/partes`, this.parte);

        this.personaNuevo = {};
        //derecho
        this.buscarExtranjeroEnPartes(this.parte.fecha_inicio, this.parte.fecha_fin, this.id_empresa);
        //izquierdo
        this.getPersonaCentroHospedaje(this.id_empresa);
        this.cargando = false;
        this.showAlert();
        //
        // this.buscarExtranjero(
        //   this.buscarNumeroDocumento,
        //   this.buscarNombres,
        //   this.buscarApellidos,
        //   this.parte
        // );
      } catch (error) {
        this.$alert(error, "Atención", "error");
        this.cargando = false;
      }
    },
    async deleteParte(id_parte) {
      this.cargando = true;
      try {
        await this.axios.delete(`/partes/${id_parte}`);
        //this.buscarExtranjeroEnPartes(this.parte.fecha_inicio, this.parte.fecha_fin, this.empresa.id_empresa);
        let fecha = this.getDate();
        this.buscarExtranjeroEnPartes(fecha, null, this.id_empresa);
        //izquierdo
        this.getPersonaCentroHospedaje(this.id_empresa);

        this.showAlertDelete();
        // this.buscarExtranjero(
        //   this.buscarNumeroDocumento,
        //   this.buscarNombres,
        //   this.buscarApellidos,
        //   this.parte
        // );
      } catch (error) {
        this.$alert(error, "Atención", "error");
        this.cargando = false;
      }
    },
    async registrarPersona() {

      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.cargando = false;
        console.log('entro invalid');
        return;
      }

      try {
        this.personaNuevo.tipo_persona = 3;
        this.personaNuevo.per_direccion = "";

        let res = await this.axios.post(`/persona`, this.personaNuevo);

        this.parte.id_persona = res.data.contenido.id_persona;
        this.parte.id_empresa = this.empresa.id_empresa;

        await this.axios.post(`/partes`, this.parte);

        this.personaNuevo = {};

        Swal.fire("EXITOSO!", `Se Guardo Correctamente!`, "success");
        this.buscarExtranjeroEnPartes(this.parte.fecha_inicio, this.parte.fecha_fin, this.empresa.id_empresa);
        this.hideModalPersona();
      } catch (error) {
        this.$alert(error, "Atención", "error");
        this.cargando = false;
      }
    },
    async getTipoDocumento() {
      try {
        let resultados = await this.axios.get(`/getParametros/DOCUMENTO`);
        this.tipoDocumentos = resultados.data.contenido;
      } catch (error) {
        console.log(error);
        
      }
    },
    async getTipoSexos() {
      try {
        let resultados = await this.axios.get(`/getParametros/PAR_SEXO`);
        this.tipoSexos = resultados.data.contenido;
      } catch (error) {
        console.log(error);
        
      }
    },
    async getNacionalidades() {
      try {
        await this.axios
          .get(`/parametrosPaises`)
          .then((response) => {
            this.nacionalidades = response.data.contenido;

            let datosCombo = [];
            for (let i = 0; i < this.nacionalidades.length; i++) {
              datosCombo.push({
                value: this.nacionalidades[i].a3_dgm,
                text: this.nacionalidades[i].nombre,
              });
            }

            this.options = datosCombo;
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log('Catch error: ',error);
      }
    },
    getDate: function() {
      return moment().format("YYYY-MM-DD");
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("-");
      return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
    },
    hideModalPersona() {
      this.$refs["registrarPersona"].hide();
    },
    showModalPersona() {
      this.$refs["registrarPersona"].show();
    },
    countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
    showAlert() {
      this.$swal({
        text: 'Ingreso Registrado',
        type: 'success',
        confirmButtonText: 'Aceptar'
      });
    },
    showAlertSalida() {
      this.$swal({
        text: 'Salida Registrada',
        type: 'success',
        confirmButtonText: 'Aceptar'
      });
    },
    countDownChangedDelete(dismissCountDownDelete) {
      this.dismissCountDownDelete = dismissCountDownDelete
    },
    showAlertDelete() {
      this.$swal({
        text: 'Registro Cancelado',
        type: 'warning',
        confirmButtonText: 'Aceptar'
      });
    },
    async salidaParte(id_parte) {
      try {
        let data = {
          id_parte: id_parte
        }
        await this.axios.put(`/parteSalida`, data);
        //this.buscarExtranjeroEnPartes(this.parte.fecha_inicio, this.parte.fecha_fin, this.empresa.id_empresa);
        let fecha = this.getDate();
        this.buscarExtranjeroEnPartes(fecha, null, this.id_empresa);
        //izquierdo
        this.getPersonaCentroHospedaje(this.id_empresa);

        this.showAlertSalida();
        // this.buscarExtranjero(
        //   this.buscarNumeroDocumento,
        //   this.buscarNombres,
        //   this.buscarApellidos,
        //   this.parte
        // );
      } catch (error) {
        this.$alert(error, "Atención", "error");
        this.cargando = false;
      }
    },
  },
  created() {
    this.getPersonaLogin();
    this.getTipoDocumento();
    this.getTipoSexos();
    this.getNacionalidades();

    // derecho
    this.item = this.$route.params.item;
    this.id_empresa = this.item.id_empresa;
    this.getPersonaCentroHospedaje(this.id_empresa);
    // izquierdo
    //let fecha = this.getDate();
    this.buscarExtranjeroEnPartes(null, null, this.id_empresa);
  },
  validations: {
    personaNuevo: {
      par_tipo_documento: { required },
      per_numero_documento: { required },
      per_nombres: { required },
      per_primer_apellido: { required },
      per_fecha_nacimiento: { required },
      per_email: { required },
      par_genero: { required },
    }
  }
};
</script>
